import { AuthService } from '../../auth/auth.service';
import { DeliveryType } from '../../coaching-base/config/delivery-type.model';
import { CommitmentDiff } from '../../coaching-base/diff-decorator';
import {
    EventParticipantDetail,
    EventParticipantDto,
} from '../../coaching-base/general';
import { MetricItem } from '../../coaching-tags/models/metric.coaching.model';
import { epicDependencies } from '../../store';

import { DiffItemsInfoView } from './diff-items-info-view.model';
import { diffItemsTransformer } from './diff-items.transformer';

export function diffItemsInfoViewFromDiffTransformer(
    diff: CommitmentDiff,
    participants: EventParticipantDetail[],
    deliveryTypes: DeliveryType[],
    metrics: MetricItem[],
): DiffItemsInfoView {
    // TODO FIXME. this can be done better. just to get current user id
    const service = epicDependencies.injector.get<AuthService>(AuthService);
    const authUserId = service.user.id;

    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const fromParticipant =
        participants.find((e) => e.id === authUserId) ||
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        ({} as EventParticipantDto);

    return {
        items: diffItemsTransformer(diff.diffItems, deliveryTypes, metrics),
        from: fromParticipant,
    };
}
